<template>
  <!-- start page title -->
  <div class="w-100 mb-4">
    <b-col class="m-0 mb-2 p-0 pb-2 d-flex align-items-center gap-2">
      <McButton
        v-if="hasBackButton"
        variant="minimal"
        size="sm"
        icon="icon-outline_arrow-left"
        :text="$t('global.back')"
        @click="handleBackButton"
      />
      <b-breadcrumb :items="items" class="m-0 p-0"></b-breadcrumb>
    </b-col>

    <div class="row">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <h4 class="mc-page-title">{{ title }}</h4>

        <slot name="afterTitle"></slot>
      </div>
      <div class="mc-sub-title col-12 d-flex align-items-center" v-if="subTitle">
        {{ subTitle }}
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>

<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  slots: ['afterTitle'],
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {
        return []
      },
    },
    hasBackButton: {
      type: Boolean,
      default: false,
    },
    routeBack: {
      type: String,
    },
  },
  methods: {
    handleBackButton() {
      if (this.routeBack) {
        return this.$router
          .push({
            path: this.routeBack,
          })
          .catch(() => {})
      }

      return this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.mc-page-title {
  font-size: 20px;
  font-weight: 700;
  color: $mep-color-text;
}

.mc-sub-title {
  color: $mep-color-text-400;
}
</style>
